<template>
  <v-row dense>
    <v-col cols="6" class="px-1 py-0">
      <autocomplete-input
        v-model="serie"
        v-bind="$props"
        :filled="filled"
        :chips="chips"
        :small-chips="smallChips"
        item-text="name"
        label="Serie"
        :items="items || choices"
        clearable
        return-object
        @input="pushUpdate"
      >
      </autocomplete-input>
    </v-col>
    <v-col cols="6" class="px-1 py-0">
      <v-text-field
        v-model="readingOrder"
        :min="1"
        type="number"
        label="Series reading order"
        clearable
        filled
        @input="pushUpdate"
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Multiple from '@ilteducation/vuetify-admin/src/mixins/multiple';
import Editable from '@ilteducation/vuetify-admin/src/mixins/editable';
import ReferenceInput from '@ilteducation/vuetify-admin/src/mixins/reference-input';

export default {
  mixins: [Input, Multiple, Editable, ReferenceInput],
  props: {
    /**
     * Serie with id, name and readingOrder.
     * @model
     */
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      serie: {
        id: this.value.id,
        name: this.value.name,
      },
      readingOrder: this.value?.readingOrder,
    };
  },
  watch: {
    value(newVal) {
      this.serie = newVal;
      this.readingOrder = newVal?.readingOrder;
    },
  },
  async created() {
    this.items = await this.fetchChoices();
  },
  mounted() {
    this.pushUpdate();
  },
  methods: {
    pushUpdate() {
      let newVal;
      if (this.serie?.id && this.serie?.name) {
        newVal = {
          id: this.serie?.id,
          name: this.serie?.name,
        };
        if (this.readingOrder) {
          newVal = { ...newVal, readingOrder: +this.readingOrder };
        }
      }
      this.update(newVal);
    },
  },
};
</script>
